import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

/**
 * Стек для хранения информации о возникающих ошибках.
 * Используется чтобы передавать ошибки из перехватчика ошибок в Error-page и OnlyIfErrorsGuard
 */

@Injectable()
export class ErrorsStackService {
    public errors$ = new BehaviorSubject<any>(null);
}
